module.exports = __webpack_public_path__ + "img/message-start.19b65d26.svg";